import styled from 'styled-components'
import { Link } from '@reach/router'

import { COLOR_GREEN } from '../../constants'

export const TextLink = styled(Link)`
	color: ${COLOR_GREEN};
	font-weight: bold;
	border-bottom: 2px solid ${COLOR_GREEN};
`